<template>
    <div id="page-container" class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header class="mdl-layout__header">
      <div class="mdl-layout__header-row page-header">
        <back-navigator></back-navigator>
        <span id="toolbar-title" class="mdl-layout-title">{{ $t('message.pageTitle') }}</span>
        <div class="mdl-layout-spacer"></div>
        <nav class="mdl-navigation">
          <language-selector theme="light" v-on:languageChanged="setLanguage($event)"></language-selector>    
        </nav>
      </div>
    </header>
    <main class="mdl-layout__content" v-if="user[0] != null">
      <div class="mdl-cell mdl-cell--12-col mdl-shadow--2dp content mdl-color-text--grey-800 card">
        <div id="user-profile-container" class="surface">
          <img id="profile-pic" :src="user[1] && user[1]['.value'] ? user[1]['.value'] : '../../static/img/userProfileIcon.svg'" :alt="$t('message.profilePicCaption')">
          <h4 id="profile-userName">{{ user[2] && user[2]['.value'] ? user[2]['.value'] : $t('message.unavailableMsg') }}</h4>
        </div>
        <div class="horizontal-divider"></div>
        <button ref="exportButton" id="exportButton" class="user-action mdc-ripple-surface" @click="exportUserData()">{{ $t('message.exportData') }}</button>
        <button class="user-action user-action-delete mdc-ripple-surface" @click="showRequestToVerify()">{{ $t('message.deleteAccount') }}</button>
      </div>
    </main>
    <dialog-component
      :status="dialogStatus"
      :message="dialogMsg"
      :positiveAction="dialogPositiveAction"
      :cancelAction="dialogCancelAction"
      :cancellable="cancellableDialog"
      v-on:dialogCancelled="dialogCancelled()"
      v-on:dialogAccepted="dialogAccepted()">
    </dialog-component>
    <footer-component :userLang="userLocale" class="footer-section"></footer-component>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'
  import Vuefire from 'vuefire'
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import 'firebase/database'
  import 'firebase/storage'
  import config from '../services/firebaseConfig'
  import axios from 'axios'
  import backNavigator from './BackNavigationComponent'
  import languageSelector from './LanguageSelectorComponent'
  import footerComponent from './Footer'
  import dialogComponent from './DialogComponent'
  import { EXPORT_DATA_URL } from '../../config/prod.env'

  if (!firebase.apps.length) {
    firebase.initializeApp(config)
  }

  const messages = {
    en: {
      message: {
        pageTitle: 'User Profile',
        profilePicCaption: 'Profile picture',
        unavailableMsg: 'NA',
        exportData: 'Export data',
        exportingData: 'Exporting data...',
        deleteAccount: 'Delete account',
        dataReadyToDownload: 'Your data is ready to download',
        downloadAction: 'DOWNLOAD',
        verifyRequest: 'To continue verify that it\'s you',
        signInAction: 'SIGN IN',
        cancelAction: 'CANCEL',
        deleteAccountWarning: 'This action is irreversible. Once you delete your account, all your polls and profile details will be deleted. We won\'t be able to recover your account.\n\n Are you sure you want to delete your account?',
        deleteAccountAction: 'DELETE ACCOUNT',
        deleteSuccess: 'Your account was deleted successfully',
        OKAction: 'OK'
      }
    },
    hi: {
      message: {
        pageTitle: 'उपयोगकर्ता प्रोफ़ाइल',
        profilePicCaption: 'प्रोफ़ाइल फोटो',
        unavailableMsg: 'अनुपलब्ध',
        exportData: 'निर्यात जानकारी',
        exportingData: 'डेटा निर्यात किया जा रहा है ...',
        deleteAccount: 'खाता हटाएं',
        dataReadyToDownload: 'आपका डेटा डाउनलोड करने के लिए तैयार है',
        downloadAction: 'डाउनलोड',
        verifyRequest: 'जारी रखने के लिए, पहले सत्यापित करें कि यह आप हैं',
        signInAction: 'साइन-इन करे',
        cancelAction: 'अभी नहीं',
        deleteAccountWarning: 'यह क्रिया अपरिवर्तनीय है। एक बार जब आप अपना खाता हटा देते हैं, तो आपके सभी मतदान और प्रोफ़ाइल विवरण हटा दिए जाएंगे। हम आपका खाता पुनर्प्राप्त नहीं कर पाएंगे। क्या आप इस खाते को हटाने के लिए सुनिश्चित हैं?',
        deleteAccountAction: 'खाता हटा दो',
        deleteSuccess: 'आपका खाता सफलतापूर्वक हटा दिया गया है',
        OKAction: 'ठीक हैं'
      }
    }
  }

  Vue.use(VueI18n)
  Vue.use(Vuefire)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    components: {
      backNavigator: backNavigator,
      languageSelector: languageSelector,
      dialogComponent: dialogComponent,
      footerComponent: footerComponent
    },
    data () {
      return {
        userLocale: i18n.locale,
        dialogMsg: '',
        dialogStatus: 'closed',
        dialogPositiveAction: 'DOWNLOAD',
        dialogCancelAction: 'CANCEL',
        cancellableDialog: false
      }
    },
    firebase () {
      return {
        user: {
          source: firebase.database().ref('users').child(firebase.auth().currentUser ? firebase.auth().currentUser.uid : 'a')
        }
      }
    },
    methods: {
      setLanguage (lang) {
        if (lang === 'en') {
          i18n.locale = 'en'
        } else if (lang === 'hi') {
          i18n.locale = 'hi'
        }
        this.userLocale = i18n.locale
        document.title = i18n.t('message.pageTitle')
      },
      exportUserData () {
        let _this = this
        let currentUser = firebase.auth().currentUser
        if (currentUser) {
          this.$refs.exportButton.innerText = i18n.t('message.exportingData')
          this.$refs.exportButton.disabled = true
          axios.post(JSON.parse(EXPORT_DATA_URL), currentUser).then(function (response) {
            _this.showDialog(i18n.t('message.dataReadyToDownload'), i18n.t('message.downloadAction'), true)
            _this.$refs.exportButton.innerText = i18n.t('message.exportData')
            _this.$refs.exportButton.disabled = false
          }).catch(() => {
            _this.$refs.exportButton.innerText = i18n.t('message.exportData')
            _this.$refs.exportButton.disabled = false
          })
        }
      },
      showRequestToVerify () {
        this.showDialog(i18n.t('message.verifyRequest'), i18n.t('message.signInAction'), true)
      },
      dialogCancelled () {
        this.dialogStatus = 'closed'
      },
      dialogAccepted () {
        let _this = this
        this.dialogStatus = 'closed'
        if (this.dialogPositiveAction === i18n.t('message.downloadAction')) {
          let currentUserID = firebase.auth().currentUser.uid
          firebase.storage().ref(`exportData/${currentUserID}/export.zip`).getDownloadURL().then(function (url) {
            var a = document.createElement('a')
            a.href = url
            a.setAttribute('type', 'hidden')
            document.body.appendChild(a)
            a.click()
            a.remove()
            setTimeout(() => window.URL.revokeObjectURL(url), 100)
            _this.$refs.exportButton.innerText = i18n.t('message.exportData')
          }).catch(function (error) {
            console.error(error)
          })
        } else if (this.dialogPositiveAction === i18n.t('message.signInAction')) {
          let _this = this
          const authProvider = firebase.auth().currentUser.providerData[0].providerId === 'facebook.com' ? new firebase.auth.FacebookAuthProvider() : new firebase.auth.GoogleAuthProvider()
          firebase.auth().currentUser.reauthenticateWithPopup(authProvider).then(function () {
            _this.showDialog(i18n.t('message.deleteAccountWarning'), i18n.t('message.deleteAccountAction'), true)
          })
        } else if (this.dialogPositiveAction === i18n.t('message.deleteAccountAction')) {
          let _this = this
          firebase.database().ref('accountsToDisable').child(firebase.auth().currentUser.uid).set(Date.now()).then(function () {
            _this.showDialog(i18n.t('message.deleteSuccess'), i18n.t('message.OKAction'), false)
          })
        } else if (this.dialogPositiveAction === i18n.t('message.OKAction')) {
          firebase.auth().signOut()
          this.$router.push('/signin')
        }
      },
      showDialog (msg, action, cancellable) {
        this.dialogMsg = msg
        this.dialogPositiveAction = action
        this.cancellableDialog = cancellable
        if (cancellable) {
          this.dialogCancelAction = i18n.t('message.cancelAction')
        }
        this.dialogStatus = 'opened'
      }
    },
    mounted () {
      document.title = i18n.t('message.pageTitle')
      if (typeof (Storage) !== 'undefined') {
        if (localStorage.getItem('recentSignIn') === 'true') {
          localStorage.setItem('recentSignIn', 'false')
          this.$router.go(0)
        }
      }
    }
  }
</script>

<style scoped>
  @import "@material/ripple/mdc-ripple";

  #page-container {
    margin-bottom: 120px;
  }

  main {
    max-width: 500px;
    width: calc(100% - 16px);
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  h4 {
    color: var(--text-color-primary);
  }

  .card {
    border-radius: 10px;
    background-color: var(--bg-color-el-1);
  }

  #user-profile-container {
    padding: 10px;
  }

  #profile-pic {
    display: block;
    margin: auto;
    width: 96px;
    height: 96px;
    border-radius: 50%;
  }

  #profile-userName {
    text-align: center;
    font-weight: 300;
  }

  .horizontal-divider {
    background-color: rgb(211, 211, 211);
    width: calc(100% - 32px);
    margin: 0 auto;
    height: 1px;
  }

  .user-action {
    width: 100%;
    background-color: transparent;
    padding: 20px;
    border: none;
    text-align: left;
    text-align: start;
    padding-left: 30px;
    font-size: 16px;
    font-weight: 300;
    color: var(--text-color-primary);
  }

  .user-action-delete {
    color: red;
    font-weight: 400;
  }

  .footer-section {
    position: fixed;
    bottom: 0px;
    width: 100%;
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserProfile.vue